import {Component, Input, OnChanges, OnInit} from '@angular/core';
import {routesNames} from '@app/app-routing.module';
import {PromotionDetail} from '@app/core/promotion/domain/dtos/promotion-detail';
import {BreadcrumbPage} from '@app/presentation/components/breadcrumb/breadcrumb-page';
import {SpecialCategories} from '../../catalog-page/catalog-page-constants';
import {PromotionDetailViewModel} from '../promotion-detail.view-model';
import {register} from 'swiper/element';

@Component({
  selector: 'app-promotion-detail-desktop',
  templateUrl: './promotion-detail-desktop.component.html',
  styleUrls: ['./promotion-detail-desktop.component.scss'],
})
export class PromotionDetailDesktopComponent implements OnChanges, OnInit {

  @Input() promotionDetail?: PromotionDetail;

  productCodes: string[] = [];

  isLoggedIn$ = this.viewModel.isLoggedIn$;

  isPriceHidden$ = this.viewModel.isPriceHidden$;

  imageViewerVisibility = false;

  breadcrumbPages: BreadcrumbPage[] = [
    {
      labelKey: "breadcrumbs.promotions",
      url: [routesNames.catalog, SpecialCategories.PROMOTIONS]
    }
  ];

  constructor(
    private viewModel: PromotionDetailViewModel
  ) { }

  ngOnInit(): void {
    register();
  }

  ngOnChanges(): void {
    this.productCodes = this.promotionDetail ? this.promotionDetail.details.map(detail => detail.code) : [];
    this.populateBreadcrumbs();
  }

  openImageViewer() {
    this.imageViewerVisibility = true;
  }

  closeImageViewer() {
    this.imageViewerVisibility = false;
  }

  private populateBreadcrumbs(): void {
    if (this.promotionDetail) {
      // Create the promotion detail breadcrumb
      let promotionBreadcrumb = {
        label: this.promotionDetail?.name,
        url: [routesNames.promotionDetail, this.promotionDetail?.code]
      }

      // And add it at the end of the list 
      this.breadcrumbPages = [...this.breadcrumbPages, promotionBreadcrumb];
    }

  }
}
